import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../sharedControllers/BaseController";
import {
  SetToken,
} from "akademika/akamont/services/AuthService";
import { TokenResponse } from "akademika/akamont/models/TokenResponse";
import { Routes } from "akademika/akamont/constants/Routes";
import { UpdateLanguageFromAccessToken } from "akademika/akamont/utils/LanguageUtil";

/**
 * @namespace akademika.akamont.pages.login
 */
export default class Login extends BaseController {
  route = Routes.LOGIN;

  public onRouteMatched(): void | Promise<void> {
    this.setModel(new JSONModel({}), "loginForm");
  }

  public async login(): Promise<void> {
    const loginForm = {
      userName: this.getModel("loginForm").getProperty("/userName"),
      password: this.getModel("loginForm").getProperty("/password"),
    };

    const loginResp = await this.post<TokenResponse>("api/Auth/Login", {
      body: loginForm,
      checkToken: false,
    });

    SetToken(loginResp);
    UpdateLanguageFromAccessToken(loginResp.accessToken, true);

    if (this.routeParams.returnRoute) {
      let returnArgs: Record<string, string> | undefined = undefined;
      if (this.routeParams.returnArgs) {
        returnArgs = JSON.parse(decodeURI(this.routeParams.returnArgs));
      }
      this.navTo(this.routeParams.returnRoute, returnArgs);
    } else this.navTo(Routes.DASHBOARD);
  }
}
